"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _statusLabelModule = _interopRequireDefault(require("./status-label.module.scss"));
var StatusLabel = function StatusLabel(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_statusLabelModule.default['status-label'], _statusLabelModule.default["status-label--".concat(variant)])
  }, children);
};
exports.StatusLabel = StatusLabel;